import actions from './actions'

const initialState = {
  userLoading: false,
  bizLoading: false,
  userStats: {},
  bizStats: {},
  WalletStats: {},
  salesAgents: [],
  selectedAgent: null,
  salesAgentLoading: false,
  agentCommission: null,
  yearlyAgentCommission: null,
  merchantFee: {},
  subAgents: [],
  payoutHistory: [],
  isSubAgentsLoading: false,
  isPayoutHistoryLoading: false,
  merchantFeeLoading: false,
  commissionLoading: false,
}

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
